<template>
  <div
    ref="chart"
    style="width:100%;height:100%">
  </div>
</template>

<script>
// 引入基本模板
const echarts = require('echarts')
export default {
  name: 'line-chart',
  data () {
    return {
      myChart: null
    }
  },
  props: {
    option: {
      type: [Object, Array]
    }
  },
  updated () {
    this.drawLine()
  },
  mounted () {
    this.drawLine()
  },
  methods: {
    drawLine () {
      const _this = this
      // 基于准备好的dom，初始化echarts实例
      _this.myChart = echarts.init(_this.$refs.chart)
      // 绘制图表
      _this.myChart.setOption(_this.option, true)
      window.addEventListener('resize', function () {
        _this.myChart.resize()
      })
    }
  },
  watch: {
    option: {
      handler (newVal, oldVal) {
        this.drawLine()
      },
      deep: true
    }
  },
  beforeDestroy () {
    if (this.myChart) {
      this.myChart.clear()
    }
  }
}
</script>

<style></style>
